import { render, staticRenderFns } from "./orderflow.vue?vue&type=template&id=7ff063ae&scoped=true&"
import script from "./orderflow.vue?vue&type=script&lang=js&"
export * from "./orderflow.vue?vue&type=script&lang=js&"
import style0 from "./orderflow.vue?vue&type=style&index=0&id=7ff063ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff063ae",
  null
  
)

export default component.exports